import React from 'react';
import PropTypes from 'prop-types';

import DynamicIcon from '../../atoms/DynamicIcon';

const PlanItem = ({ plan, className, experiment = false }) => (
  <div className={`plan-item-simple ${className}`} aria-hidden="true">
    {plan.isRecommend && <p className="plan-item-simple_recommend">Recomendado</p>}
    <div className={`plan-item-simple_content ${plan.isRecommend ? 'recommend' : ''}`}>
      <div>
        <h4>{plan.name}</h4>
        <div className="plan-item-simple_price">
          <span>Precio desde:</span>
          <div className="plan-item-simple_price--detail">
            <span className="plan-item-simple_price--detail-price">
              <small>{plan.currency}</small>
              {experiment ? plan.dailyPrice : plan.price}
            </span>
            <span className="plan-item-simple_price--detail-period">/{experiment ? plan.minPeriod : plan.period}</span>
          </div>
        </div>
        <div className="plan-item-simple_coverage">
          <p className="plan-item-simple_coverage--title">Cobertura{plan.coverages.length > 1 ? 's' : ''}:</p>
          <div className="plan-item-simple_coverage--list">
            {plan.coverages.map((coverage) => (
              <div key={coverage.id} className="plan-item-simple_coverage--list-item">
                <DynamicIcon icon={coverage.icon} size="large" />
                <span>{coverage.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

PlanItem.propTypes = {
  plan: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    dailyPrice: PropTypes.number,
    currency: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    minPeriod: PropTypes.string,
    isRecommend: PropTypes.bool.isRequired,
    coverages: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
  className: PropTypes.string,
  experiment: PropTypes.bool.isRequired,
};

PlanItem.defaultProps = {
  className: '',
};

export default PlanItem;
